import RestService from "../RestService";
import REST_URLS from "../RestUrls.constants";

const base = REST_URLS.QUESTION_BANK.baseUrl;
const endpoints = REST_URLS.QUESTION_BANK.endpoints;

export default {
  getQuestions() {
    let url = base + endpoints.getQuestions;
    return RestService.getRequest(url);
  },

  submitQuestion(data) {
    let url = base + endpoints.submitQuestion;
    return RestService.postRequest(url, data);
  },

  updateQuestion(data) {
    let url = base + endpoints.updateQuestion;
    return RestService.postRequest(url, data);
  },

  deleteQuestion(_id) {
    let url = base + endpoints.deleteQuestion;
    return RestService.deleteRequest(url, { _id });
  }
};
